import useUserInfo from '@src/hooks/useTtsUser';
import { EXPORT_RETENTION_PERIOD } from '@src/constants/project';

/**
 * Days an exported file stays downloadable, for the package the user is on.
 *
 * The value belongs to the package, not to the product: a free account keeps a
 * file for fewer days than a paid one, so a constant here shows one of them the
 * wrong number. `EXPORT_RETENTION_PERIOD` remains the answer only while the
 * user has not loaded, where a missing number would render as `undefined`.
 */
const useExportRetentionPeriod = () => {
  const { ttsUser } = useUserInfo();

  return ttsUser?.retentionPeriod || EXPORT_RETENTION_PERIOD;
};

export default useExportRetentionPeriod;
